import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';
import { app } from './firebase';

export default function AnalyticsListener() {
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    isSupported().then((supported) => {
      if (!supported || cancelled) return;
      const analytics = getAnalytics(app);
      logEvent(analytics, 'page_view', {
        page_path: location.pathname,
      });
    });
    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  return null;
}
